<template>
	<div v-if="user.subscription">
		<h3>Indirizzo di consegna</h3>

		<template v-if="orderClosed">
			<p>Non è più possibile modificare indirizzo e giorno di consegna poichè l'ordine è già in elaborazione</p>
		</template>

		<template v-else>
			<div v-if="user.order">
				<template >
					<p>Puoi modificare indirizzo e giorno di consegna fino a {{ $_dates_dateCutOff }}. <br>Modifiche valide per l'ordine in consegna il {{ dateDelivery }}.</p>
					<change-subscription-full-form style='max-width: 700px'/>
				</template>
			</div>
			<div v-else>
				<p>Puoi modificare il tuo indirizzo e giorno di consegna in fase d'ordine.</p>

	             <div v-if="address && delivery">
	              <div>
	               <div>{{ delivery.name }}</div>
	               <div>{{ address.street }}</div>
	               <div>{{ address.zip_code }}, {{ address.city }}</div>
	               <div>{{ $t("components.subscription_form.default.telephone") }}: {{ delivery.phone }}</div>
	               <div v-if="delivery.notes">{{ $t("components.subscription_form.default.message") }}: {{ delivery.notes }}</div>
	             </div>
	            </div>
			</div>
		</template>
	</div>
</template>

<script>
import { dates } from '../../mixins/dates'
import ChangeSubscriptionFullForm from '../Delivery/ChangeSubscriptionFullForm'
import { deliveryStore } from '../../store/deliveryStore'
import { orderStore } from '../../store/orderStore'

export default {
	mixins: [
		dates,
	],

	components: {
		ChangeSubscriptionFullForm
	},
	data() {
		return {
        	deliveryStore: deliveryStore.state,
		}
	},
	computed: {
		user () {
			return this.$root.user
		},

		orderClosed () {
			return this.user.order && this.user.order.closed
		},

		dateDelivery () {
			if (this.user.order && this.user.order.date) return this.$_dates_readableDate(this.user.order.date.delivery)
			return this.$_dates_nextWeekDay(this.user.subscription.delivery_day)
		},
		address () {
            return this.delivery
                && this.deliveryStore
                && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id)
                && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id).attributes
        },

        delivery () {
            var sub = this.user && this.user.subscription
            return sub 
                && this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
        },
	},

	mounted () {
		this.$_dates_loadDelivery()
	}
}

</script>
